export default {
  INVESTMENT_TYPE_HIRING_STEP_STATE_MANAGER: Symbol.for('INVESTMENT_TYPE_HIRING_STEP_STATE_MANAGER'),
  INVESTMENT_TYPE_HIRING_STEP_REPOSITORY: Symbol.for('INVESTMENT_TYPE_HIRING_STEP_REPOSITORY'),
  CREATE_INVESTMENT_TYPE_HIRING_STEP_COMMAND: Symbol.for('CREATE_INVESTMENT_TYPE_HIRING_STEP_COMMAND'),
  SEARCH_INVESTMENT_TYPE_HIRING_STEP_QUERY: Symbol.for('SEARCH_INVESTMENT_TYPE_HIRING_STEP_QUERY'),
  UPDATE_INVESTMENT_TYPE_HIRING_STEP__COMMAND: Symbol.for('UPDATE_INVESTMENT_TYPE_HIRING_STEP__COMMAND'),
};
